import { em } from "@mantine/core";

export const ResponsiveSize = {
    mobile: em(750)
}